interface Props {
  errorString: any; //  string;
}
const ErrorTopToaster: React.FC<Props> = ({ errorString }) => {
  // console.log("errorString", errorString)
  //this class will add for seession timeout (error-top-msg session-time-out)
  return (
    <div
      id="error-top"
      className={`${
        errorString == "Patient info updated successfully" ||
        errorString == "User info updated successfully" ||
        errorString == "Code Resent."
          ? "error-top-msg success"
          : "error-top-msg"
      } `}
    >
      <h2>{errorString}</h2>
    </div>
  );
};
export default ErrorTopToaster;
